export default {"src":"/_next/static/media/users.4955cdbe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};